// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pe-0";
export var animationContainer = "_pe-1";
export var itemPrice = "_pe-a";
export var itemizedContent = "_pe-9";
export var itemizedHeader = "_pe-7";
export var itemizedRow = "_pe-8";
export var itemizedSection = "_pe-6";
export var modalContent = "_pe-2";
export var orderName = "_pe-3";
export var refundOption = "_pe-4";
export var refundOptionsContainer = "_pe-5";
export var shippingLabel = "_pe-b";
export var totalRow = "_pe-c";